import { memo } from 'react';
import { SpaceBetween } from '@amzn/awsui-components-core';

import SectionEditorControl from '../v2-common/SectionEditorControl';
import NextPageButton from '../v2-content-editor/NextPageButton';
import { useGuideReadonlyViewModel } from './GuideReadonlyViewModel';
import { useReportPageLoadTime } from '../../monitoring/PageLoadTimeReporter';
import styles from './GuideReadonlyView.module.scss';

interface GuideReadonlyViewProps {
  /** Whether this body reports the view page's load time once it renders. */
  readonly isPageLoadTracked: boolean;
}

/** Read-only Guide body: the current page's sections, rendered without edit affordances. */
export const GuideReadonlyView = memo(function GuideReadonlyView({
  isPageLoadTracked,
}: GuideReadonlyViewProps) {
  const vm = useGuideReadonlyViewModel();

  // When the tracked Guide body first renders (a view model exists, so this view returns more
  // than null), then report the view page as loaded.
  useReportPageLoadTime('view', isPageLoadTracked && vm !== undefined);

  if (!vm) return null;

  return (
    <SpaceBetween size="l">
      {vm.isPageBodyVisible && (
        <SectionEditorControl
          key={`${vm.currentPage.id}-body`}
          node={vm.currentPage}
          contentId={vm.contentId}
          title={vm.pageTitle}
          isReadonly
          isTitleHidden
        />
      )}
      {vm.sections.map((section) => (
        <SectionEditorControl
          key={section.id}
          node={section}
          contentId={vm.contentId}
          title={section.title}
          isReadonly
        />
      ))}
      <div className={styles.nextPageButtonRow}>
        <NextPageButton nextPage={vm.nextPage} />
      </div>
    </SpaceBetween>
  );
});
